import { I18nService as a } from "@perxis-auto/shared";
import { StageEntityId as r } from "@perxis-auto/trade-in-sdk/types";
import { APP as e } from "../../../../shared/config/app.js";
const m = (n) => {
  const { t } = a.getInstance().i18n;
  switch (n) {
    case r.STAGE_3:
      return t("stage.forward.byStage.third", { ns: e.name });
    case r.STAGE_4:
      return t("stage.forward.byStage.fourth", { ns: e.name });
    default:
      return "";
  }
};
export {
  m as GET_FORWARD_BUTTON_TEXT_MAP
};
